import type { PatternValueSystemValueBatch, PatternValueSystemValueDocument, PatternValueSystemValueDocumentFile } from '~/common/model/api/batch-type';

/** Batch path. */
export const BATCH_PATH: Record<PatternValueSystemValueBatch, string> = {
  batchId: 'id',
  batchName: 'name',
  batchType: 'type',
  batchPriority: 'priority',

  documentCount: 'documents',

  createdBy: 'created',
  createdByEmail: 'created_by',
  createdAt: 'created_at',
  createdAtDate: 'created_at',
  createdAtTime: 'created_at',

  lastUpdatedBy: 'updated',
  lastUpdatedByEmail: 'updated_by',
  lastUpdatedAt: 'updated_at',
  lastUpdatedAtDate: 'updated_at',
  lastUpdatedAtTime: 'updated_at',
};

/** Document path batch prefix. */
export const DOCUMENT_PATH_BATCH_PREFIX = 'batch.';

/** Document path. */
export const DOCUMENT_PATH: Record<PatternValueSystemValueDocument | PatternValueSystemValueDocumentFile, string> = {
  documentName: 'name',
  documentType: 'type',
  separationConfidence: 'separation_confidence',
  classificationConfidence: 'classification_confidence',
  extractionConfidence: 'extraction_confidence',

  filePdfBase64: 'file_pdf_base64',
};
